import { wOrgIdMiddleware } from "../utils/commonUtils";
import { OK } from "../utils/constant";
import http from "./http";

const EmrVisitsService = {
  getWorkStatusSummary: wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-work-status-summary`
        );
        if(response.code === OK){
          return response?.data;
        } else {
          return null;
        }
      } catch (error) {
        console.error("Get work status summary error", error);
        throw error;
      }
    },
  ),
 
    savePreVisitData: wOrgIdMiddleware(async (url,employeeId, visitId) => {
    try {
      const response = await http.POST(
        `${url}employee/${employeeId}/${visitId}/get-pre-visit-data`
      );
      return response.data;
    } catch (error) {
      console.error("Pre-visit data error", error);
      throw error;
    }
  }),
  saveMostRecentVisitData: wOrgIdMiddleware(async (url, employeeId, visitId) => {
    try {
      const response = await http.POST(
        `${url}employee/${employeeId}/${visitId}/get-most-recent-visit-data`
      );
      return response.data;
    } catch (error) {
      console.error("Most recent visit data error", error);
      throw error;
    }
  }),
  clearVisitData: wOrgIdMiddleware(async (url, visitId) => {
    try {
      const response = await http.GET(
        `${url}${visitId}/clearEmrData`
      );
      return response.data;
    } catch (error) {
      console.error("Clear visit data error", error);
      throw error;
    }
  }),
  generateSummary:wOrgIdMiddleware(async (url,visitId) => {
    try {
      const response = await http.POST(
          `${url}${visitId}/emr/summary`,
      );
      return response.data;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  fetchFieldsBySearch: wOrgIdMiddleware(async (url, screen_type = "", data) => {
    try {
      const response = await http.POST(
        `/emr-chart/${url}${screen_type}/emr-search`,
        data
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }, true),
  getEmrChartByScreen: wOrgIdMiddleware(async (url, screen_type, visit_id, query={}) => {
   try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}${visit_id}/get-emr-chart/${screen_type}?${queryString}`);
      return response; // <- return only the array inside `data`
    } catch (error) {
      return [];
    }
  }),
  saveFields: wOrgIdMiddleware(
    async (url, visit_id = "", form_id = "", data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/emr-chart-view/${form_id}/save-emr-chart`,
          data
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },
    true
  ),

  fetchFilledFieldData: wOrgIdMiddleware(
    async (url, visit_id = "", form_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/emr-chart-view/${form_id}/show-emr-chart`
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },
    true
  ),
  searchActivities: wOrgIdMiddleware(async (url, screen_type = "", data) => {
    try {
      const response = await http.POST(
        `/emr-chart/${url}${screen_type}/getAutoListChart`,
        data
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }, true),
  searchHistory: wOrgIdMiddleware(async (url, screen_type = "") => {
    try {
      const response = await http.GET(
        `/emr-chart/${url}${screen_type}/get-emr-search-history`
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }, true),

  searchHistory: wOrgIdMiddleware(async (url, screen_type = "") => {
    try {
      const response = await http.GET(
        `/emr-chart/${url}${screen_type}/get-emr-search-history`
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }, true),

  addEmrDocuments: wOrgIdMiddleware((
    async (url, visit_id, data, headers = {
      'Content-Type': 'multipart/form-data'
    }) => {
      try {
        const response = await http.POST(`${url}${visit_id}/emr-documents`, data, headers);
        
        if ((response.code === 200 || response.code === 201) && response.data) {
          return response.data;
        } else {
          return response;
        }
      } catch (error) {
        console.error('Error fetching user:', error);
        if (error.status) {
          const resData = error.data;
          if (resData.code && resData.data) {
            return resData;
          }
        }
      }
    })
),
getEmrDocuments: wOrgIdMiddleware((
  async (url, visit_id, search = '', sortBy = 'updated_at', sortOrder = 'desc') => {
    try {
      const queryParams = new URLSearchParams();
      if (search) {
        queryParams.append('search', search);
      }
      if (sortBy) {
        queryParams.append('sort_by', sortBy);
      }
      if (sortOrder) {
        queryParams.append('sort_order', sortOrder);
      }
      const queryString = queryParams.toString();
      const response = await http.GET(`${url}${visit_id}/emr-documents${queryString ? `?${queryString}` : ''}`);
      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
    }
  })
),

deleteEmrDocuments: wOrgIdMiddleware((
  async (url, visit_id,DELETE_ID) => {
    try {
      const response = await http.DELETE(`${url}${visit_id}/emr-documents/${DELETE_ID}`);
      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
    }
  })
),

  saveChartNotes: wOrgIdMiddleware(async (url, type ,visitId,payload) => {
    try {
      const response = await http.POST(
       `${url}${visitId}/chart-note/${type}`,
       payload
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  getChartNotes: wOrgIdMiddleware(async (url, type, visitId, includePmh = true) => {
    try {
      const query = includePmh ? "?include_pmh=1" : "?include_pmh=0";
      const response = await http.GET(
        `${url}${visitId}/chart-note/${type}${query}`
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  getCombinedChartNotePdf: wOrgIdMiddleware(async (url, visitId, includePmh = true) => {
    try {
      const query = includePmh ? "?include_pmh=1" : "?include_pmh=0";
      const response = await http.GET(
        `${url}${visitId}/print-combined-chart-note${query}`
      );
      return response;
    } catch (error) {
      console.error("Combined chart note PDF error", error);
      throw error;
    }
  }),
  getEditChartNotes: wOrgIdMiddleware(async (url,visitId) => {
    try {
      const response = await http.GET(
        `${url}${visitId}/get-chart-note/print_chartnote`
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  sendNotes: wOrgIdMiddleware(async (url,visitId,data) => {
    try {
      const response = await http.POST(
        `${url}${visitId}/save-chart-note`,data
      );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  getUpdatedNotes: wOrgIdMiddleware(async (url,visitId) => {
    try {
      const response = await http.GET(
        `${url}${visitId}/get-chart-note/editable` );
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),

  saveAssessment: wOrgIdMiddleware(
    async (url='', visit_id = "", icd_id = "", data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/emr-assessment/save-assessment-chart/${icd_id}`,
          data
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },
    true
  ),

  getAssessmentICD10DList: wOrgIdMiddleware(
    async (url, visit_id = "", query = {}) => {
      try {
        const queryString = new URLSearchParams(query).toString();
        const response = await http.GET(
          `${url}${visit_id}/emr-assessment/get-assessment?${queryString}`
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },
    true
  ),

  getAssessmentDataById: wOrgIdMiddleware(
    async (url, visit_id = "", id) => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/emr-assessment/get-assessment/${id}`
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },
    true
  ),
    getAssessmentData: wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/emr-assessment/get-assessment-details`
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },
    true
  ),
  getWorkRestrictionById: wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-emr-work-restriction`
        );
        if(response.code===OK){
           return response?.data;
        }else{
          return null
        }
       
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
  SaveWorkRestriction: wOrgIdMiddleware(
    async (url, visit_id = "", data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/save-emr-work-restriction`,
          data
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
  getSchoolNoteById: wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-emr-school-note`
        );
        if (response.code === OK) {
          return response?.data;
        } else {
          return null;
        }
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
  SaveSchoolNote: wOrgIdMiddleware(
    async (url, visit_id = "", data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/save-emr-school-note`,
          data
        );
        return response;
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
  printSchoolNote: wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/print-school-note`
        );
        if (response.code === OK) {
          return response?.data || response;
        } else {
          console.error("Print school note failed:", response);
          return null;
        }
      } catch (error) {
        console.error("Print school note error", error);
        throw error;
      }
    },
  ),
    ListOrders: wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-orders-results`
        );
        if(response.code===OK){
           return response?.data;
        }else{
          return null
        }
       
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    ListPreviousOrders: wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-orders-history`
        );
        if(response.code===OK){
           return response?.data;
        }else{
          return null
        }
       
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    DeleteOrder: wOrgIdMiddleware(
      async (url, lab_order_id = "") => {
        try {
          const response = await http.DELETE(
            `${url}delete-emr-activity-visit/${lab_order_id}`
          );
          if(response.code===OK){
             return response?.data;
          }else{
            return null
          }
         
        } catch (error) {
          console.error("delete error", error);
          throw error;
        }
      },),
    getEmployeeVisitLab:wOrgIdMiddleware(
    async (url, visit_id = "",id='') => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-orders-results/${id}`
        );
        if(response.code===OK){
           return response?.data;
        }else{
          return null
        }
       
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    saveEmployeeVisitLab: wOrgIdMiddleware(
    async (url, visit_id = "", data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/save-lab-results`,
          data
        );
           return response
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    saveEmployeeVisitLab1: wOrgIdMiddleware(
      async (url, visit_id = "", data) => {
        try {
          const response = await http.POST(
            `${url}${visit_id}/save-vaccine-results`,
            data
          );
             return response
        } catch (error) {
          console.error("Save error", error);
          throw error;
        }
      },),
    updateEmployeeVisitLab: wOrgIdMiddleware(
    async (url, visit_id = "",id, data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/save-orders-results/${id}`,
          data
        );
        return response
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    getVitalsList:wOrgIdMiddleware(
    async (url, visit_id = "") => {
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-emr-vitals`
        );
        if(response.code===OK){
           return response?.data;
        }else{
          return null
        }
       
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    saveVitals: wOrgIdMiddleware(
    async (url, visit_id = "", data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/save-emr-vitals`,
          data
        );
           return response
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
     updateVitals: wOrgIdMiddleware(
    async (url, visit_id = "",id, data) => {
      try {
        const response = await http.POST(
          `${url}${visit_id}/save-emr-vitals/${id}`,
          data
        );
        return response
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    getVitalsHistory:wOrgIdMiddleware(
    async (url, visit_id = "",query={}) => {
      const queryString = new URLSearchParams(query).toString();
      try {
        const response = await http.GET(
          `${url}${visit_id}/get-vitals-history?${queryString}`
        );
        if(response.code===OK){
           return response?.data;
        }else{
          return null
        }
       
      } catch (error) {
        console.error("Save error", error);
        throw error;
      }
    },),
    deleteVitalHistory: wOrgIdMiddleware(
    async (url, visit_id, vitalHistoryId) => {
      try {
        const response = await http.DELETE(
          `${url}${visit_id}/delete-vital-history/${vitalHistoryId}`
        );
        if(response.code===OK || response.code===200){
           return response;
        }else{
          return response;
        }
       
      } catch (error) {
        console.error("Delete vital history error", error);
        throw error;
      }
    },),
    saveReferralSelection: wOrgIdMiddleware(
      async (url, visit_id = "", data) => {
        try {
          const response = await http.POST(
            `${url}${visit_id}/emr-referrals`,
            data
          );
          return response;
        } catch (error) {
          console.error("Save error", error);
          throw error;
        }
      },),
      getReferralSelection: wOrgIdMiddleware(
        async (url, visit_id = "") => {
          try {
            const response = await http.GET(
              `${url}${visit_id}/emr-referrals`
            );
            return response;
          } catch (error) {
            console.error("Save error", error);
            throw error;
          }
        },),
          getActivityCharges: wOrgIdMiddleware(async (url,visit_id="") => {
            try {
              const response = await http.GET(
               `${url}get-emr-price/${visit_id}` );
              return response;
            } catch (error) {
              console.error("Save error", error);
              throw error;
            }
          }),
          mapVisitIncident: wOrgIdMiddleware(async (url, visit_id = "", data) => {
            try {
              const response = await http.POST(
                `${url}${visit_id}/map-visit-incident`,
                data
              );
              return response;
            } catch (error) {
              console.error("Map incident error", error);
              throw error;
            }
          }, false),
      sendChartNotesEmail: wOrgIdMiddleware(async (url, visit_id, email, includePmh = true, includeDemographics = false) => {
        try {
          const response = await http.POST(
            `${url}${visit_id}/send-chart-notes-email`,
            { email, include_pmh: !!includePmh, include_demographics: !!includeDemographics }
          );
          if(response.code===OK){
              return response;
            }
          return null;
        } catch (error) {
          console.error("Error sending email", error);
          throw error;
        }
      }),
      getWorkStatusSummary: wOrgIdMiddleware(
        async (url, visit_id = "") => {
          try {
            const response = await http.GET(
              `${url}${visit_id}/get-work-status-summary`
            );
            if(response.code===OK){
               return response?.data;
            }else{
              return null
            }
           
          } catch (error) {
            console.error("Get work status summary error", error);
            throw error;
          }
        },
      ),
      getWorkStatusFormWithMapping: wOrgIdMiddleware(
        async (url, visit_id = "") => {
          try {
            const response = await http.GET(
              `${url}${visit_id}/get-work-status-form-with-mapping`
            );
            if(response.code===OK){
               return response?.data;
            }else{
              return null
            }
           
          } catch (error) {
            console.error("Get work status form with mapping error", error);
            throw error;
          }
        },
      ),
      saveWorkStatusForm: wOrgIdMiddleware(
        async (url, visit_id = "", data) => {
          try {
            const response = await http.POST(
              `${url}${visit_id}/save-work-status-form`,
              data
            );
            return response;
          } catch (error) {
            console.error("Save work status form error", error);
            throw error;
          }
        },
      ),
      getWorkStatusFormById: wOrgIdMiddleware(
        async (url, visit_id = "") => {
          try {
            const response = await http.GET(
              `${url}${visit_id}/get-work-status-form`
            );
            if(response.code===OK){
               return response?.data;
            }else{
              return null
            }
           
          } catch (error) {
            console.error("Get work status form by id error", error);
            throw error;
          }
        },
      ),
      printPatientDemography: wOrgIdMiddleware(
        async (url, visit_id = "") => {
          try {
            const response = await http.GET(
              `${url}${visit_id}/print-patient-demography`
            );
            if (response.code === OK) {
              // API returns base64 string in data
              return response?.data || response;
            }
            return null;
          } catch (error) {
            console.error("Print patient demography error", error);
            throw error;
          }
        },
      ),
      printWorkStatusForm: wOrgIdMiddleware(
        async (url, visit_id = "") => {
          try {
            const response = await http.GET(
              `${url}${visit_id}/print-work-status-form`
            );
            console.log("Print work status form API response:", response);
            if(response.code===OK){
               // Return the data - it should be the base64 string
               return response?.data || response;
            }else{
              console.error("Print work status form failed:", response);
              return null
            }
           
          } catch (error) {
            console.error("Print work status form error", error);
            throw error;
          }
        },
      ),

      sendWorkStatusFormEmail: wOrgIdMiddleware(
        async (url, visit_id, email, recipientType = 'patient') => {
          try {
            const response = await http.POST(
              `${url}${visit_id}/send-work-status-form-email`,
              {
                email,
                baseUrl: process.env.REACT_APP_BASEURL,
                recipient_type: recipientType,
              }
            );
            return response;
          } catch (error) {
            console.error("Send work status form email error", error);
            throw error;
          }
        },
      ),

      sendSchoolNoteEmail: wOrgIdMiddleware(
        async (url, visit_id, email = null) => {
          try {
            const payload = {
              baseUrl: process.env.REACT_APP_BASEURL,
            };

            if (email) {
              payload.email = email;
            }

            const response = await http.POST(
              `${url}${visit_id}/send-school-note-email`,
              payload
            );
            return response;
          } catch (error) {
            console.error("Send school note email error", error);
            throw error;
          }
        },
      ),
      sendWorkStatusFormSMS: wOrgIdMiddleware(
        async (url, visit_id, phone) => {
          try {
            const response = await http.POST(
              `${url}${visit_id}/send-work-status-form-sms`,
              { 
                phone,
                baseUrl: process.env.REACT_APP_BASEURL
              }
            );
            return response;
          } catch (error) {
            console.error("Send work status form SMS error", error);
            throw error;
          }
        },
      ),

  getPrescribedMedications: wOrgIdMiddleware(
    async (url, visitId, query = {}) => {
      try {
        const queryString = new URLSearchParams(query).toString();
        const response = await http.GET(
          `${url}employee-visits/${visitId}/prescribed-medications?${queryString}`
        );
        if (response.code === OK) {
          return response.data;
        }
        return null;
      } catch (error) {
        console.error("Get prescribed medications error", error);
        throw error;
      }
    },
  ),

  savePrescribedMedications: wOrgIdMiddleware(
    async (url, visitId, data) => {
      try {
        const response = await http.POST(
          `${url}employee-visits/${visitId}/prescribed-medications`,
          data
        );
        if (response.code === OK || response.code === 201) {
          return response.data;
        }
        throw new Error(response.data?.error || "Failed to save prescribed medications");
      } catch (error) {
        console.error("Save prescribed medications error", error);
        throw error;
      }
    },
  ),

  getPrescribedMedicationById: wOrgIdMiddleware(
    async (url, visitId, prescriptionId) => {
      try {
        const response = await http.GET(
          `${url}employee-visits/${visitId}/prescribed-medications/${prescriptionId}`
        );
        if (response.code === OK) {
          return response.data;
        }
        return null;
      } catch (error) {
        console.error("Get prescribed medication by ID error", error);
        throw error;
      }
    },
  ),

  updatePrescribedMedications: wOrgIdMiddleware(
    async (url, visitId, prescriptionId, data) => {
      try {
        const response = await http.PUT(
          `${url}employee-visits/${visitId}/prescribed-medications/${prescriptionId}`,
          data
        );
        if (response.code === OK || response.code === 200) {
          return response.data;
        }
        throw new Error(response.data?.error || "Failed to update prescribed medications");
      } catch (error) {
        console.error("Update prescribed medications error", error);
        throw error;
      }
    },
  ),

  deletePrescribedMedications: wOrgIdMiddleware(
    async (url, visitId, prescriptionId) => {
      try {
        const response = await http.DELETE(
          `${url}employee-visits/${visitId}/prescribed-medications/${prescriptionId}`
        );
        if (response.code === OK || response.code === 200 || response.code === 204) {
          return response.data;
        }
        throw new Error(response.data?.error || "Failed to delete prescribed medications");
      } catch (error) {
        console.error("Delete prescribed medications error", error);
        throw error;
      }
    },
  ),
  printPrescribedMedication: wOrgIdMiddleware(
    async (url, visitId, prescriptionId) => {
      try {
        const response = await http.GET(
          `${url}employee-visits/${visitId}/prescribed-medications/${prescriptionId}/print`
        );
        if (response.code === OK) {
          return response?.data || response;
        }
        throw new Error(response.data?.error || "Failed to print prescribed medication");
      } catch (error) {
        console.error("Print prescribed medication error", error);
        throw error;
      }
    },
  ),
  printBulkPrescribedMedications: wOrgIdMiddleware(
    async (url, visitId, prescriptionIds) => {
      try {
        const response = await http.POST(
          `${url}employee-visits/${visitId}/prescribed-medications/bulk-print`,
          { prescription_ids: prescriptionIds }
        );
        if (response.code === OK) {
          return response?.data || response;
        }
        throw new Error(response.data?.error || "Failed to print bulk prescribed medications");
      } catch (error) {
        console.error("Print bulk prescribed medications error", error);
        throw error;
      }
    },
  ),

  
};
export default EmrVisitsService;
